import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'
import Picture from '../Picture'
import RichText from '../RichText'
import RoundedTag from '../RoundedTag'
import Icon from '../Icon'

export const _Picture = styled(Picture)`
  @media ${mq(sizes.tablet)} {
    max-width: ${pxToRem(332)};
    align-self: flex-start;
  }

  overflow: hidden;
  @media (hover: hover) {
    img {
      transition: 0.6s ease;
    }
  }
`
export const _Icon = styled(Icon)`
  display: none;
  @media ${mq(sizes.desktop)} {
    flex: 0 0 auto;
    display: flex;
    width: ${pxToRem(88)};
    margin-inline-start: auto;

    @media (hover: hover) {
      transition: 0.6s ease;
      translate: ${pxToRem(-20)};
    }
  }
`

export const Container = styled.article`
  color: inherit;
`
export const _Link = styled(Link)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  color: inherit;
  @media ${mq(sizes.tablet)} {
    flex-flow: row;
    align-items: center;
  }
  @media ${mq(sizes.big)} {
    gap: ${pxToRem(132)};
  }

  @media (hover: hover) {
    &:hover {
      ${_Picture} {
        img {
          scale: 1.025;
        }
      }
      ${_Icon} {
        translate: 0;
      }
    }
  }
`

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
`
export const Tags = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: ${pxToRem(12)};
`
export const _RoundedTag = styled(RoundedTag)``
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_h3}
  line-height: 1.2;
  @media ${mq(sizes.desktop)} {
    max-width: max(${pxToRem(564)}, 40vw);
    ${Content}:first-child & {
      max-width: max(${pxToRem(1128)}, 80vw);
    }
  }
`
export const Metas = styled.div`
  display: flex;
  gap: ${pxToRem(16)};
  align-items: center;
  &:not(:first-child) {
    margin-block-start: ${pxToRem(16)};
  }
`
export const Date = styled.time`
  ${({ theme }) => theme.textStyles.m375_tags}
  display: flex;
  align-items: center;
`
export const ReadingTime = styled.span`
  ${({ theme }) => theme.textStyles.m375_tags}
  display: flex;
  align-items: center;
  gap: ${pxToRem(4)};
  text-transform: uppercase;
  opacity: 0.7;
`
export const ReadingIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(16)};
  translate: 0 ${pxToRem(-2)};
`
